import * as React from 'react';

export default class _404 extends React.Component<any, any> {
  render() {
    return <div>404 page</div>;
  }
}
